"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayMessageSubType = void 0;
const validations_1 = require("../../../utils/validations");
const TrackerMessage_1 = __importDefault(require("../TrackerMessage"));
var RelayMessageSubType;
(function (RelayMessageSubType) {
    RelayMessageSubType["RTC_OFFER"] = "rtcOffer";
    RelayMessageSubType["RTC_ANSWER"] = "rtcAnswer";
    RelayMessageSubType["RTC_CONNECT"] = "rtcConnect";
    RelayMessageSubType["ICE_CANDIDATE"] = "iceCandidate";
})(RelayMessageSubType = exports.RelayMessageSubType || (exports.RelayMessageSubType = {}));
class RelayMessage extends TrackerMessage_1.default {
    constructor({ version = TrackerMessage_1.default.LATEST_VERSION, requestId, originator, targetNode, subType, data }) {
        super(version, TrackerMessage_1.default.TYPES.RelayMessage, requestId);
        (0, validations_1.validateIsNotNullOrUndefined)('originator', originator);
        (0, validations_1.validateIsNotEmptyString)('targetNode', targetNode);
        (0, validations_1.validateIsOneOf)('subType', subType, Object.values(RelayMessageSubType));
        (0, validations_1.validateIsNotNullOrUndefined)('data', data);
        this.originator = originator;
        this.targetNode = targetNode;
        this.subType = subType;
        this.data = data;
    }
    isRtcOfferMessage() {
        return this.subType === RelayMessageSubType.RTC_OFFER;
    }
    isRtcAnswerMessage() {
        return this.subType === RelayMessageSubType.RTC_ANSWER;
    }
    isRtcConnectMessage() {
        return this.subType === RelayMessageSubType.RTC_CONNECT;
    }
    isIceCandidateMessage() {
        return this.subType === RelayMessageSubType.ICE_CANDIDATE;
    }
}
exports.default = RelayMessage;
//# sourceMappingURL=RelayMessage.js.map